/*-----------------------------------------------------------------
- Base configs
-----------------------------------------------------------------*/
const config = {
    propClasses: {
        fab: 'is-fab',
    },

    prefix: {
        accordion    : 'y-accordion',
        accordionItem: 'y-accordion-item',
        alert        : 'y-alert',
        badge        : 'y-badge',
        breadcrumb   : 'y-breadcrumb',
        button       : 'y-button',
        buttonGroup  : 'y-button-group',
        checkbox     : 'y-checkbox',
        chips        : 'y-chips',
        col          : 'y-col',
        container    : 'y-container',
        copyValue    : 'y-copy-value',
        datePicker   : 'y-date-picker',
        division     : 'y-division',
        dropdown     : 'y-dropdown',
        dropdownItem : 'y-dropdown-item',
        empty        : 'y-empty',
        fieldWrapper : 'y-field-wrapper',
        form         : 'y-form',
        goftino      : 'y-goftino',
        icon         : 'y-icon',
        image        : 'y-image',
        input        : 'y-input',
        loadMore     : 'y-load-more',
        loading      : 'y-loading',
        loop         : 'y-loop',
        map          : 'y-map',
        menu         : 'y-menu',
        menuItem     : 'y-menu-item',
        modal        : 'y-modal',
        pageContent  : 'y-page-content',
        pagination   : 'y-pagination',
        player       : 'y-player',
        panel        : 'y-panel',
        radio        : 'y-radio',
        range        : 'y-range',
        rayChat      : 'y-ray-chat',
        recaptcha    : 'y-recaptcha',
        row          : 'y-row',
        select       : 'y-select',
        selectFlag   : 'y-select-flag',
        selectMap    : 'y-select-map',
        slide        : 'y-slide',
        slideshow    : 'y-slideshow',
        socials      : 'y-socials',
        stepper      : 'y-stepper',
        table        : 'y-table',
        textarea     : 'y-textarea',
        toggle       : 'y-toggle',
        treeSelect   : 'y-tree-select',
        uploader     : 'y-uploader',
        validator    : 'y-validator',
        shared       : 'y-shared',
    },

    loading: {
        type: 'spring-spinner',
    },
};

export default config;
